// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JcAy","right":"styles_right__Y9y5N"};